// extracted by mini-css-extract-plugin
module.exports = {"contentLayout":"contentLayout--1sOFF"};